
// Utility functions for photo moderation and placeholder handling

export const MODERATED_CONTENT_PLACEHOLDER = '/moderated-content-placeholder.svg';

export const isModeratedContent = (photoUrl: string): boolean => {
  return photoUrl === MODERATED_CONTENT_PLACEHOLDER || 
         photoUrl.includes('moderated-content-placeholder');
};

export const shouldShowPlaceholder = (photoUrl: string): boolean => {
  return isModeratedContent(photoUrl);
};

export const getModerationReason = (photoUrl: string): string => {
  // In the future, we could encode reason in the URL or fetch from logs
  return "Content moderated for community guidelines compliance";
};
